import { takeLatest, put, call, select, debounce } from 'redux-saga/effects';
import { GET_USERS_REQUEST, GET_TYPING_USERS_REQUEST, getUsersSuccess, getUsersFailure } from '../actions/users';
import { getUsers } from '../services/users';
import { getProfileInstallerID, getProfilesWorker } from '../../profiles/sagas/profiles';
import { showGlobalError } from '../../app/actions/app';
import { accessTokenSelector } from '../../auth/selectors/token';
import { profilesAccessor } from '../../profiles/selectors/profiles';

export const getUsersWorker = function*({ payload: { filters } }) {
    try {
        yield call(getProfilesWorker, { payload: { filters: {} } });

        if (filters.getOnlyUsersInstaller) {
            filters.profile = yield call(getProfileInstallerID);
            delete filters.getOnlyUsersInstaller;
        }

        const token = yield select(accessTokenSelector);
        const { profiles } = yield select(profilesAccessor);

        const {
            data: { users, total }
        } = yield call(getUsers, filters, token);

        yield put(getUsersSuccess(users, total, profiles));
    } catch (err) {
        yield put(getUsersFailure(err));
        yield put(showGlobalError(true, err));
    }
};

export default [takeLatest(GET_USERS_REQUEST, getUsersWorker), debounce(500, GET_TYPING_USERS_REQUEST, getUsersWorker)];
